import { render, staticRenderFns } from "./ProductsDropdown.vue?vue&type=template&id=213fc2f4&scoped=true&"
import script from "./ProductsDropdown.vue?vue&type=script&lang=js&"
export * from "./ProductsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ProductsDropdown.vue?vue&type=style&index=0&id=213fc2f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213fc2f4",
  null
  
)

export default component.exports